import { isAfter } from 'date-fns';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

export const useIsJiraNewUserTraitCrossFlowSelector = ({
	crossFlowProduct = 'jpd',
}: {
	crossFlowProduct?: 'jpd' | 'confluence';
} = {}) =>
	createTraitsSelector<'SITE_USER'>('SITE_USER', ({ getTraitValue }) => {
		if (!fg('jira_ybr_precondition_check_rollout_cross_flow')) {
			return false;
		}

		try {
			const firstActiveDate = getTraitValue('jira_first_active');

			if (
				!firstActiveDate ||
				!(typeof firstActiveDate === 'string') ||
				firstActiveDate.trim() === ''
			) {
				return false;
			}

			// This is to get the target new user date from dynamic config jira-ybr-first-batch-new-users-cross-flow and jira-ybr-first-batch-new-users-cross-flow-jpd
			// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/jira-ybr-first-batch-new-users-cross-flow
			// and https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/jira-ybr-first-batch-new-users-cross-flow-jpd
			// We confirm that this is a working way to get the value from the dynamic config
			// Other Jira teams are using this approach as well (filtered target app jira_web on dynamic config and confirmed)

			if (crossFlowProduct === 'confluence') {
				return isAfter(
					new Date(firstActiveDate),
					new Date(
						expVal('jira-ybr-first-batch-new-users-cross-flow', 'value', '2050-12-31T00:00:00Z'),
					),
				);
			}

			return isAfter(
				new Date(firstActiveDate),
				new Date(
					expVal('jira-ybr-first-batch-new-users-cross-flow-jpd', 'value', '2050-12-31T00:00:00Z'),
				),
			);
		} catch (error) {
			fireErrorAnalytics({
				error: error instanceof Error ? error : undefined,
				meta: {
					id: 'useIsJiraNewUserTraitCrossFlowSelector',
					packageName: 'yellowBrickRoadUtils',
					teamName: 'jira-werewolves',
				},
			});
			return false;
		}
	})();
